import React from "react";
import Service from '../service/Service';
const service = new Service();
import * as actions from './actions';
export default function CollectionListPopup({ eleRef, eleRecord, eleName }) {
    
//     var items = [];
    
//     [].forEach.call(eleRef, function (value, key) {
//         items.push(<li key={key} className="dev_selcoll" onClick={(e) => actions.selectlist(`${eleRecord}`, `${value.coll_id}`, `${eleName}`)}>
//             <div className="baby_img">
//                 <img src="http://cdn.fcglcdn.com/brainbees/apps/image/baby_name_icon.png" className="dev_selcollimg" />
//             </div>
//             <div className="M14_42">
//                 <span className="coll_title"> {value.coll_name} </span>
//             </div>
//             <div className="M14_pink">
//                 <span className="dev_selcoll"> {value.count} </span>
//                 <span className="dev_selcolltxt"> Name(s) </span>
//             </div>
//         </li>
//         )
//     });
//     {/*    
//     // actions.loadImages();
//     // init();
//     // actions.hideLoader();
//     // var listnumber = $(".collection-list-popup .collection-list li").length;
//     // var listwidth = $(".collection-list-popup .collection-list li:first-child").width();
//     // $(".collection-list-popup .collection-list").width((listnumber * listwidth) + (listnumber * 35)); */}

//     return (
//         <div>
//             <div className="collection-list-popup">
//                 <div className="collection">
//                     <div className="collection-part1">
//                         <span className="selct-title M18_42"> Select the collection list </span>
//                         <span className="create-ic right" onClick={() => actions.createlist()} >
//                             Create + 
//                         </span>
//                         <div className="list" id="list">
//                             <ul className="collection-list">{items}</ul>
//                         </div>
//                         <span className="next" onClick={(e) => service.slideSlider('list', 300, 1000)}>
//                             <span data-icon-font="h" className="icon"></span>
//                         </span>
//                         <span className="prev" onClick={(e) => service.slideSlider('list', -300, 1000)}>
//                             <span data-icon-font="g" className="icon"></span>
//                         </span>
//                     </div>
//                     { /*<!--norecord starts--> */}
//                     <div className="norecord-overlay left">
//                         <div className="norecord_alert">
//                             <div className="M16_42">  No collection list created yet. </div>
//                             <div className="R14_9e"> Please create the one to shortlist the cute baby names.
//                             </div>
//                         </div>
//                     </div>
//                     { /*<!--norecord ends--> */}
//                     <div className="new-collection">
//                         <div className="selct-title  M18_42"> Create New Collection </div>
//                         <span className="M14_42"> Collection Name </span>
//                         <input type="text"
//                             placeholder="Family's, Father, Mother"
//                             className="input-name"/>
//                         <span className="error_msg R11_red"> </span>
//                         <div className="popup-btns right">
//                             <span className="cancel-popup M14_9e" onClick={(e) => actions.cancelCreate_popup(e)}> CANCEL </span>
//                             <span className="M14_pink dev_create_addfavname" onClick={(e) => this.createNewCollection(e)}>
//                                 CREATE 
//                             </span>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="name-added">
//                 <div className="nm-add">
//                     <span>
//                     </span>
//                 </div>
//             </div>
//             </div>
//     )
// }
        var headers = 'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken+',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop;

        return (
                <div className="collection-list-popup" id="collection-list-popup" hidden>
                    <div className="collection-wrapper">
                    <span className="icon popupclose" data-icon-font="C" role="button" tabIndex="0" on="tap:collection-list-popup.hide"></span>
                    <div className="collection">
                        
                        <div className="collection-part1 left" id="collection-part1" hidden>
                                <span className="selct-title M18_42"> Select the collection list </span>
                                <span className="create-ic right" role="button" tabIndex="0" on="tap:collection-part1.hide,new-collection.show">
                                    Create + 
                                </span>
                                {eleRef.length > 0 ?
                                    <div className="list" id="list">
                                        <amp-carousel height="186" layout="fixed-height" type="carousel">
                                            {eleRef.map((value, index) => 
                                                <form method="post" action-xhr={`${global.hosturl}parenting/BabynamesAmp/savefavouritename`} encType="application/json">
                                                    <input type="hidden" name="headerdata" value={headers} />
                                                    <input type="hidden" name="recordId" data-amp-bind-value="eleRecord" />
                                                    <input type="hidden" name="favouriteId" value="" />
                                                    <input type="hidden" name="eleName" data-amp-bind-value='eleName' />
                                                    <input type="hidden" name="action_status" value="1" />
                                                    <input type="hidden" name="currentUrl" value={global.currentURL}/>
                                                    <label htmlFor={`addin${value.coll_id}`}>
                                                        <div key={index} className="experts-cnt" tabIndex="0" role="button" on="tap:success-overlay.show">
                                                            <input type="hidden" name="collectionId" value={value.coll_id} />
                                                            <div className="expert-image">
                                                                <amp-img layout="responsive" width="130" height="98" src="http://cdn.fcglcdn.com/brainbees/apps/image/baby_name_icon.png"></amp-img>
                                                            </div>
                                                            <div className="M14_42">
                                                                <span className="coll_title"> {value.coll_name} </span>
                                                            </div>
                                                            <div className="M14_pink">
                                                                <span className=""> {value.count} </span>
                                                                <span className=""> Name(s) </span>
                                                            </div>
                                                            <input type="submit" value="" name="addToCollection" id={`addin${value.coll_id}`} hidden/>

                                                            <div className="success-msg" submit-success="">
                                                                <template type="amp-mustache">
                                                                    Successfull added to {value.coll_name}!!!
                                                                </template>
                                                            </div>
                                                            <div className="error-msg" submit-error="">
                                                                <template type="amp-mustache">
                                                                Error!, please try again.
                                                                </template>
                                                            </div>
                                                        </div>
                                                        
                                                    </label>
                                                </form>                 
                                            )}
                                        </amp-carousel>
                                    </div>
                                    :
                                    <div className="norecord-overlay left">
                                        <div className="norecord_alert">
                                            <div className="M16_42">  No collection list created yet. </div>
                                            <div className="R14_9e"> Please create the one to shortlist the cute baby names.
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        <div className="new-collection" id="new-collection" hidden>
                            <form method="post" id="postcollection" action-xhr={`${global.hosturl}parenting/BabynamesAmp/postcollection`} encType="application/json">
                                    
                                    <input type="hidden" name="currentUrl" value={global.currentURL}/>
                                    <input type="hidden" name="headerdata" value={headers} />
                                
                                    <div className="selct-title  M18_42"> Create New Collection </div>
                                    <span className="M14_42"> Collection Name </span>
                                    <input type="text"
                                        placeholder="Family's, Father, Mother"
                                        className="input-name" name="input-name"/>
                                    <span className="error_msg R11_red"> </span>
                                    <div className="popup-btns right">
                                        <span className="cancel-popup M14_9e" tabIndex="0" role="button" on="tap:collection-list-popup.hide,new-collection.hide"> CANCEL </span>
                                        
                                        <label htmlFor="newCollection">
                                            <input type="submit" id="newCollection" name="newCollection" value=""/>
                                            <span className="M14_pink dev_create_addfavname" id="dev_lst_crt" tabIndex="0" role="button" >
                                                CREATE 
                                            </span>
                                        </label>
                                    </div>
                                
                            </form>
                        </div>
                    </div>
                    </div>
                </div>
                
        )
    }



// WEBPACK FOOTER //
// src/shared/baby-names-amp/CollectionListPopupAmp.js